import { type Itoken } from '../pages/Login/loginGoogle';

// eslint-disable-next-line import/prefer-default-export
export const TOKEN: Itoken = JSON.parse(
  localStorage.getItem('TOKEN') as string
);
